<template>
  <div>
    <loader :loading="loading"/>
    <div v-if="!loading">
      <page-title title="Resumo de produtos disponibilizados">
        <div slot="header-icon">
          <img :src="fromModuleDefinition.logo" class="logo" alt="">
          <i class="i-arrow icon-arrow-right"></i>
          <img :src="toModuleDefinition.logo" class="logo" alt="">
        </div>
      </page-title>
      <div class="l-row">
        <div class="l-col-3@md" v-for="product in products" :key="product.productId">
          <component :is="marketplaceProvideReportProduct" ref="items" :product="product"/>
        </div>
      </div>

      <panel>
        <button class="btn btn--success" @click="done">{{ $t('done.label') }}</button>
      </panel>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { upperFirst } from 'lodash'
  import Panel from '@/components/template/Panel'
  import PageTitle from '@/components/template/PageTitle'
  import MarketplaceProvideReportProductSkyhub from '@/components/marketplace/skyhub/provide/report/Product'
  import MarketplaceProvideReportProductShopee from '@/components/marketplace/shopee/provide/report/Product'
  import MarketplaceProvideReportProductNetshoes from '@/components/marketplace/netshoes/provide/report/Product'
  import MarketplaceProvideReportProductColombo from '@/components/marketplace/colombo/provide/report/Product'
  import MarketplaceProvideReportProductIntegracommerce from '@/components/marketplace/integracommerce/provide/report/Product'
  import MarketplaceProvideReportProductCnova from '@/components/marketplace/cnova/provide/report/Product'
  import MarketplaceProvideReportProductLeroy from '@/components/marketplace/leroy/provide/report/Product'
  import MarketplaceProvideReportProductCarrefour from '@/components/marketplace/carrefour/provide/report/Product'
  import MarketplaceProvideReportProductWebcontinental from '@/components/marketplace/webcontinental/provide/report/Product'
  import MarketplaceProvideReportProductWalmart from '@/components/marketplace/walmart/provide/report/Product'
  import MarketplaceProvideReportProductMadeira from '@/components/marketplace/madeira/provide/report/Product'
  import MarketplaceProvideReportProductGfg from '@/components/marketplace/gfg/provide/report/Product'
  import MarketplaceProvideReportProductZoom from '@/components/marketplace/zoom/provide/report/Product'
  import MarketplaceProvideReportProductCentauro from '@/components/marketplace/centauro/provide/report/Product'
  import MarketplaceProvideReportProductAmazon from '@/components/marketplace/amazon/provide/report/Product'
  import MarketplaceProvideReportProductPrivalia from '@/components/marketplace/privalia/provide/report/Product'
  import MarketplaceProvideReportProductSicredi from '@/components/marketplace/sicredi/provide/report/Product'
  import MarketplaceProvideReportProductMaisCorreios from '@/components/marketplace/maisCorreios/provide/report/Product'
  import MarketplaceProvideReportProductSicoob from '@/components/marketplace/sicoob/provide/report/Product'
  import MarketplaceProvideReportProductPolishop from '@/components/marketplace/polishop/provide/report/Product'
  import MarketplaceProvideReportProductRicardoEletro from '@/components/marketplace/ricardoEletro/provide/report/Product'
  import MarketplaceProvideReportProductRenner from '@/components/marketplace/renner/provide/report/Product'
  import Loader from '@/components/template/Loader'

  export default {
    data: () => ({
      loading: true,
      saving: false
    }),
    props: {
      fromModuleType: {
        type: String,
        required: true
      },
      fromModuleIdentifier: {
        type: String,
        required: true
      },
      toModuleType: {
        type: String,
        required: true
      },
      toModuleIdentifier: {
        type: String,
        required: true
      }
    },
    async mounted () {
      if (!this.products.length) {
        this.redirectToProductProvideList()
      }

      this.loading = false
    },
    computed: {
      ...mapGetters('sendProducts', [
        'getAllVariations'
      ]),
      ...mapGetters('module', [
        'getDefinitionModuleByIdentifierAndType'
      ]),
      products () {
        return this.getAllVariations()
      },
      fromModuleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType(this.fromModuleType, this.fromModuleIdentifier)
      },
      toModuleDefinition () {
        return this.getDefinitionModuleByIdentifierAndType(this.toModuleType, this.toModuleIdentifier)
      },
      marketplaceProvideReportProduct () {
        return `MarketplaceProvideReportProduct${upperFirst(this.toModuleIdentifier)}`
      }
    },
    methods: {
      redirectToProductProvideList () {
        this.$router.push(`/${this.fromModuleType}/${this.fromModuleIdentifier}/products`)
      },
      done () {
        this.$router.push(`/${this.toModuleType}/${this.toModuleIdentifier}/products`)
      }
    },
    components: {
      Panel,
      PageTitle,
      Loader,
      MarketplaceProvideReportProductSkyhub,
      MarketplaceProvideReportProductShopee,
      MarketplaceProvideReportProductNetshoes,
      MarketplaceProvideReportProductColombo,
      MarketplaceProvideReportProductIntegracommerce,
      MarketplaceProvideReportProductCnova,
      MarketplaceProvideReportProductLeroy,
      MarketplaceProvideReportProductCarrefour,
      MarketplaceProvideReportProductWebcontinental,
      MarketplaceProvideReportProductWalmart,
      MarketplaceProvideReportProductMadeira,
      MarketplaceProvideReportProductGfg,
      MarketplaceProvideReportProductZoom,
      MarketplaceProvideReportProductCentauro,
      MarketplaceProvideReportProductAmazon,
      MarketplaceProvideReportProductPrivalia,
      MarketplaceProvideReportProductRicardoEletro,
      MarketplaceProvideReportProductRenner,
      MarketplaceProvideReportProductSicredi,
      MarketplaceProvideReportProductMaisCorreios,
      MarketplaceProvideReportProductSicoob,
      MarketplaceProvideReportProductPolishop
    }
  }
</script>



// WEBPACK FOOTER //
// Report.vue?3026ade7